import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';

import ListItem from './ListItem';
import BookImage from './BookImage';
import Icon from './Icon';
import Text from './Text';
import { useTheme } from 'styled-components';
import Box from './layout/Box';

import { formatBook } from '../helpers/formatBook';

const BookListItem = ({
  book,
  after,
  disabled,
  showCreated,
  showPrice,
  className,
}) => {
  const theme = useTheme();

  const { id, fullTitle, author, price, image } = formatBook(book);

  const now = DateTime.local();

  const createdAt = DateTime.fromMillis(parseInt(book.updatedAt, 10));

  let dayText = createdAt.setLocale('sv-SE').toRelativeCalendar();
  const fromToday = now.hasSame(createdAt, 'day');
  const dayDiff = now.diff(createdAt, 'days').toObject().days;

  if (dayDiff > 2) {
    dayText = createdAt.setLocale('sv-SE').toFormat('yyyy-MM-dd');
  }

  const meta = [];

  if (showCreated) {
    meta.push(
      <Text variant="listItemTag">
        {dayText} {fromToday && createdAt.toFormat('HH:mm')}
      </Text>,
    );
  }

  if (showPrice) {
    meta.push(<Text variant="listItemTag">{price} kr</Text>);
  }

  return (
    <Link
      key={`new-book-${id}`}
      to={disabled ? null : `/book?i=${id}`}
      style={{ color: 'black' }}
      className={className}
    >
      <ListItem
        key={id.toString()}
        before={<BookImage bookId={id} source={image} size={60} />}
        after={
          after || (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                height: 'inherit',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: 10,
              }}
            >
              <Icon
                name="chevron-right-outline"
                color={theme.colors.mediumGrayColor}
                size={32}
              />
            </div>
          )
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
            marginLeft: 10,
            overflow: 'hidden',
          }}
        >
          <Text variant="listItemTitle">{fullTitle}</Text>

          {author && <Text variant="listItemSubtitle">av {author}</Text>}

          {meta.length > 0 && (
            <Box className="flex-row align-items-center">
              {meta.map((item, index) => {
                const isLast = meta.length - 1 === index;

                return (
                  <Box
                    className="align-items-center"
                    key={`meta-${index.toString()}`}
                  >
                    {item}
                    {!isLast && (
                      <Box
                        className="mx-2"
                        backgroundColor="mediumGrayColor"
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: 10,
                        }}
                      />
                    )}
                  </Box>
                );
              })}
            </Box>
          )}
        </div>
      </ListItem>
    </Link>
  );
};

BookListItem.defaultProps = {
  showBorder: true,
  showCreated: true,
  showPrice: true,
};

export default BookListItem;
